import BarChartGraph from './BarChartGraph';

export default BarChartGraph;
